export const MODULE = 'BILLING_BPLS';
export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;
export const UPLOAD_LIST = `${MODULE}/upload_list`;
export const SHOW_UPLOADED = `${MODULE}/show_uploaded`
export const BPLS_DOWNLOAD = "api/v1/administrators/file_uploads/{id}/download_failed";
export const DELETE_FILE_UPLOAD = "BILLINGS/delete_file_upload";
export const DELETE_FILE_HISTORY_UPLOAD = "BILLINGS/delete_file_history_upload";

// for manual import (Smart City)
export const LIST_MANUAL_IMPORT = `${MODULE}/list_manual_import`;
export const SHOW_MANUAL_IMPORT = `${MODULE}/show_manual_import`;
export const CREATE_RECORD_MANUAL_IMPORT = `${MODULE}/create_record_manual_import`;
export const UPDATE_RECORD_MANUAL_IMPORT = `${MODULE}/update_record_manual_import`;
export const DELETE_RECORD_MANUAL_IMPORT = `${MODULE}/delete_record_manual_import`;

const initialFees = [
  { particulars: 'Garbage Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Sanitary Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Health Certification - Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Annual Tax Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Laboratory Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Occupational', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Application Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Cetification Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Sticker Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: 'Signbard (Orinary)', tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: "Mayor's permit", tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: "Fire Inspection Feee", tax_due: 0, interest: 0, surcharge: 0, total: 0},
  { particulars: "Annual Building Inspection Fee", tax_due: 0, interest: 0, surcharge: 0, total: 0},
]

export const INITIAL_FORMDATA = {
  bin: '',
  tdp_no: '',
  assessment_date: '',
  expiration_date: '',
  account_name: '',
  type: '',
  account_no: '',
  business_name: '',
  owners_name: '',
  street: '',
  barangay_code: '',
  municipality_code: '',
  province_code: '',
  // region_code: '080000000', // eastern visayas (region VIII)
  region_code: '',
  zip_code: '',
  tax_year: '',
  contact_no: '',
  initial_activities: [],
  initial_fees: initialFees,
  first_qtr_amount: '',
  second_qtr_amount: '',
  third_qtr_amount: '',
  fourth_qtr_amount: '',
}
export const INITIAL_ACTIVITY_FORM = {
  line_of_business: '',
  capital_amount: '',
  non_essential_gross_amount: '',
  essential_gross_amount: '',
}
export const INITIAL_FEES_FORM = {
  particulars: '',
  tax_due: '',
  interest: '',
  surcharge: '',
  total: '',
}
export const TRANSACTION_TYPE = [
  {label: "NEW", value: "NEW"},
  {label: "RENEWAL", value: "RENEWAL"},
]